module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('titles.patientinfo')) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.setPatientInformation(_vm.patientData, _vm.overwrite = true)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('buttons.usecontactinfo')) + "\n      ")])], 1), _vm._v(" "), _c('v-card-text', [_c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.patient
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('titles.medicalaid')) + "\n    ")]), _vm._v(" "), _c('v-card-text', [_c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.medical_aid,
      "field-configs": _vm.formsets.medical_aid_config
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "slot": "is_dependent",
      "label": "Patient is a dependant"
    },
    slot: "is_dependent",
    model: {
      value: (_vm.medicalaid.is_dependent),
      callback: function($$v) {
        _vm.$set(_vm.medicalaid, "is_dependent", $$v)
      },
      expression: "medicalaid.is_dependent"
    }
  }), _vm._v(" "), _c('template', {
    slot: "name-after"
  }, [_c('span', {
    staticClass: "overline"
  }, [_vm._v("Quick picks")]), _vm._v(" "), _vm._l((_vm.quickpicks), function(pick) {
    return _c('v-chip', {
      key: pick,
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      },
      on: {
        "click": function($event) {
          _vm.medicalaid.name = pick
        }
      }
    }, [_vm._v(_vm._s(pick))])
  })], 2)], 2), _vm._v(" "), (_vm.medicalaid.is_dependent) ? _c('div', [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Main member details")]), _vm._v(" "), (_vm.medicalaid.is_dependent) ? _c('object-form', {
    attrs: {
      "touch": _vm.touch,
      "fields": _vm.formsets.main_member
    },
    model: {
      value: (_vm.medicalaid),
      callback: function($$v) {
        _vm.medicalaid = $$v
      },
      expression: "medicalaid"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7af1475c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/MedicalAidDetails.vue
// module id = 1479
// module chunks = 9